module.exports = __webpack_public_path__ + "img/avatar-25.87bfd64d.png";